import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ShipmentAppEntityShipmentItemRead } from '../../../openapi';
import { selectLoading, selectShipment } from '../../../store/selectors/my-cases.selectors';
import { loadShipmentItem } from '../../../store/actions/my-cases.actions';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { PaymentStatusCheckerComponent } from '../../../common/payment-status-checker/payment-status-checker.component';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';

@Component({
  selector: 'app-my-case-payment-status-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterLink,
    PaymentStatusCheckerComponent,
    SpinnerComponent
  ],
  templateUrl: './my-case-payment-status-page.component.html'
})
export class MyCasePaymentStatusPageComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payment_token'] || this.route.snapshot.queryParams['payum_token'];

  public shipment: Signal<ShipmentAppEntityShipmentItemRead | null> = this.store$.selectSignal(selectShipment);

  public serviceTypeName: Signal<string> = computed(() => this.shipment()?.caseEntity?.applications?.at(0)?.service?.name || '');

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public ngOnInit(): void {
    this.store$.dispatch(loadShipmentItem({ id: this.route.snapshot.params['shipmentId'] }));
  }
}
